import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Tabs, App, Pagination, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getSuggestProductList } from '@/api/order';
import YourTownloopSuggestList from '../../components/YourTownloopProductList/YourTownloopSuggestList';
import { eventBus } from '@/utils/eventBus';
import { getUserFollowList } from '@/api/user';
import { saveUserFollow } from '@/api/store';

import styles from './FollowedStores.module.scss';
import { useTranslation } from 'react-i18next';
import { get } from 'http';
import icon1 from '@/assets/images/Merchant _url.png';
import emptyImage from '@/assets/images/base/no-data.png';


interface TabItem {
  label: string;
  key: string;
}
interface PageParams {
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

const FollowedStores: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { message } = App.useApp();
  //tabItems切换
const tabItems: TabItem[] = [
  { label: "FollowedStores.All", key: '0' },
  { label: "FollowedStores.Store", key: '1' },
  { label: "FollowedStores.Product", key: '2' },
  { label: "FollowedStores.Service", key: '3' },
];
  // 商品推荐
  const [suggestions, setSuggestions] = useState<any[]>([]);
  // 关注店铺
  const [storeList, setStoreList] = useState<any>([]);
  // 分页
  const [pageParams, setPageParams] = useState<PageParams>({
    page: 1,
    page_size: 10,
    total_pages: 0,
    total: 0
  });
  //tab切换
  const [activeTab, setActiveTab] = useState('0');
  // 分页信息
  const [goToPage, setGoToPage] = useState<string>('');
  // 跳转到指定页
  const handleGoToPage = () => {
    const page = parseInt(goToPage);
    if (isNaN(page) || page < 1) {
      return;
    }
    if (page > pageParams.total_pages) {
      return;
    }
    setPageParams({
      ...pageParams,
      page: page
    });
    getUserFollowListFn();
  };
  //获取商品id
  const getId = (id: string) => {
    console.log('id', id);
    navigate(`/ProductDetail/${id}`);
  }
  //切换tab事件
  const changeTab = (key: string) => {
    setActiveTab(key);
  }
  const getUserFollowListFn = async () => {
    const newParams: {
      page: number;
      page_size: number;
      follow_type: 1 | 2;
    } = {
      page: pageParams.page,
      page_size: pageParams.page_size,
      follow_type: 1
    }
    const res = await getUserFollowList(newParams);
    if (res.code === 200) {
      console.log('res', res)
      res.data.follow_list.forEach((item: any) => {
        item.logo = item.logo && item.logo !== '' ? item.logo : icon1
      })
      setStoreList(res.data.follow_list)
      const { current_page, page_size, total_count, total_pages } = res.data.pagination
      setPageParams({ page: current_page, page_size: page_size, total: total_count, total_pages: total_pages });
    }
  }
  // 分页变化
  const paginationChange = (page: number, page_size: number) => {
    setPageParams({ ...pageParams, page, page_size });
    getUserFollowListFn();
  };
  // 处理页码输入框回车事件
  const handlePageInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleGoToPage();
    }
  };
  // 获取推荐商品列表
  const getSuggestProductListFn = () => {
    getSuggestProductList({ num: 5 }).then((res) => {
      if (res.code == 200) {
        setSuggestions(res.data);
      }
    });
  }
  // 访问店铺
  const onStoreVisitBtnClick = (item: any) => {
    navigate(`/storeDetail/${item.follow_id}`)
  }

  // 访问商品
  const jumpToProduct = (id: string) => {
    navigate(`/ProductDetail/${id}`)
  }

  useEffect(() => {
    getSuggestProductListFn()
    getUserFollowListFn()
  }, [])

  const onUnfollowBtnClick = async (item: any) => {
    const res =  await saveUserFollow({
      follow_id: item.follow_id,
      is_delete: true
    })
    if (res.code == 200) {
      message.success(t('FollowedStores.Unfollow'));
      getUserFollowListFn();
    }
  }
  const renderFollowStoreList = () => {
    if (storeList.length > 0) {
      return storeList.map((item: any, index: number) => (
            <>
            <div className={`${styles['list-item']}`} key={index}>
              <div className={styles['time-box']}>
                <div className={styles['time-left']}>
                  <img className={styles['time-avatar']} src={item.logo} alt="" />
                  <div className={styles['time-left-info']}>
                    <span className={styles['time-left-title1']}>{item.name}</span>
                    <span className={styles['time-left-followed']}>{item.description}</span>
                  </div>
                </div>
                <div className={styles['time-right']}>
                  <button className={styles['time-btn']} onClick={() => onStoreVisitBtnClick(item)}>{t('FollowedStores.VisitTheStore')}</button>
                  <button className={styles['time-btn']} onClick={() => onUnfollowBtnClick(item)}>{t('FollowedStores.Unfollow')}</button>
                </div>
              </div>
            </div>
            <div className={`${styles.flex} ${styles['items-center']} ${index === storeList.length - 1 ? '' : styles['mb-5']}`}>
            {
              Array.isArray(item.product_list) && item.product_list.length > 0 && item.product_list.map((product: any, key: number) => (
                <div className={`${styles['md-w-1/3']} ${styles['lg-w-1/4']} ${styles['xl-w-1/5']} ${styles['mr-2']} ${styles['cursor-pointer']}`} onClick={() => jumpToProduct(product.product_id)} key={key}>
                  <img className={styles['product-img']} src={product.product_media_list[0].product_media_file_url} alt="" />
                  <div className='line-clamp-1 text-sm'>
                    {product.product_title ?? ''}
                  </div>
                  <div className='text-sm font-bold'>
                    ${product.product_sku_values?.[0]?.product_price || ''}
                  </div>
                </div>
              ))
            }
            </div>
            </>
          ))
    }
    else {
      return <div className={`${styles['history-box']} ${styles['items-center']}`}>
        <img src={emptyImage} className={styles['empty_image']} />
        <div className={styles['mt-2']}>
          {t("FollowedStores.NoFollowedStores")}
        </div>
        </div>
    }
  }
  return (
    <div className={styles['history-box']}>
      <div className={styles['favorites-box']}>
        <div className={styles['suggest-title']}>{t("YourFavorites.SuggestedForYou")}</div>
        <YourTownloopSuggestList products={suggestions} getId={getId}></YourTownloopSuggestList>
        <div className={styles['favorites-top-content']}>
          <div className={styles['favorites-text-box']}>
            <div className={styles['favorites-text']}>
              {t("YourFavorites.YourFollowing")}
            </div>
          </div>
        </div>
      </div>
      <div className={styles['list']}>
        {
          renderFollowStoreList()
        }
      </div>
      {storeList.length > 0 &&
        <div className={styles['pagination-container']}>
          <div className={styles['pagination-info']}>{t("searchList.Total")} {pageParams.total} {t("searchList.Products")}</div>
          <Pagination
            onChange={paginationChange}
            current={pageParams.page}
            pageSize={pageParams.page_size}
            total={pageParams.total}
            showSizeChanger={false}
            responsive
            hideOnSinglePage={pageParams.total_pages <= 1}
          />
          <div className={styles['go-to-page']}>
            {t("searchList.goto")}
            <input
              className={styles['page-input']}
              type="text"
              value={goToPage}
              onChange={(e) => setGoToPage(e.target.value)}
              onKeyDown={handlePageInputKeyDown}
            />
            {t("searchList.page")}
            <Button
              size="small"
              style={{ marginLeft: 8 }}
              onClick={handleGoToPage}
            >
              {t("searchList.GO")}
            </Button>
          </div>
        </div>
      }
    </div>
  );
};

export default FollowedStores; 